"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const PUBLIC_MODELS_FILE_NAME_SEED_CACHE_KEY = "publicModelsFileNameSeed";
const DEFAULT_IMGIX_PARAMS = {
  fit: "max"
};
exports.DEFAULT_IMGIX_PARAMS = DEFAULT_IMGIX_PARAMS;
exports.PUBLIC_MODELS_FILE_NAME_SEED_CACHE_KEY = PUBLIC_MODELS_FILE_NAME_SEED_CACHE_KEY;
//# sourceMappingURL=constants.cjs.map
